import { getAllTextNodes } from "./get-all-text-nodes";

export function replaceSelectedHtml(
  sel,
  document,
  replacementText,
  removeSelection = true,
) {
  var sel, range;
  if (document.getSelection) {
    sel = document.getSelection();
    if (sel.rangeCount) {
      range = sel.getRangeAt(0);
      range.deleteContents();

      // Range.createContextualFragment() would be useful here but is
      // non-standard and not supported in all browsers (IE9, for one)
      const el = document.createElement("div");
      el.innerHTML = replacementText;
      let frag = document.createDocumentFragment(),
        node,
        lastNode;
      while ((node = el.firstChild)) {
        lastNode = frag.appendChild(node);
      }
      if (frag.childNodes.length === 0) {
        lastNode = document.createTextNode("");
        frag.appendChild(lastNode);
      }
      // console.log(frag.childNodes, lastNode);
      range.insertNode(frag);

      // To remove selection and place caret at end of selection
      if (removeSelection && lastNode) {
        const rangeNew = document.createRange();
        rangeNew.setStart(lastNode, lastNode.length);
        rangeNew.setEnd(lastNode, lastNode.length);
        // console.log(rangeNew);
        sel.removeAllRanges();
        sel.addRange(rangeNew);
        // range = range.cloneRange();
        // range.setStartAfter(lastNode);
        // range.collapse(true);
        // sel.removeAllRanges();
        // sel.addRange(range);
      } else if (removeSelection) {
      }
    }
  } else if (document.selection && document.selection.createRange) {
    // IE < 9
    range = document.selection.createRange();
    range.text = replacementText;
  }
}

export function replaceSelectedElement(
  sel,
  document,
  replacementElement,
  removeSelection = true,
) {
  var sel, range;
  if (document.getSelection) {
    sel = document.getSelection();
    if (sel.rangeCount) {
      range = sel.getRangeAt(0);
      range.deleteContents();
      range.insertNode(replacementElement);

      // To remove selection and place caret at end of selection
      if (removeSelection && replacementElement) {
        range = range.cloneRange();
        range.setStartAfter(replacementElement);
        range.collapse(true);
        sel.removeAllRanges();
        sel.addRange(range);
        return;
      }

      // Modify the selection to select all childrens
      var allTextNodes = getAllTextNodes(replacementElement);
      var firstChild = allTextNodes[0];
      var lastChild = allTextNodes.at(-1);

      const rangeNew = document.createRange();
      rangeNew.setStart(firstChild ? firstChild : replacementElement, 0);
      rangeNew.setEnd(
        lastChild ? lastChild : replacementElement,
        lastChild ? lastChild.length : 0,
      );
      sel.removeAllRanges();
      sel.addRange(rangeNew);
      return { firstChild, lastChild };
    }
  } else if (document.selection && document.selection.createRange) {
    // IE < 9
    // range = document.selection.createRange();
    // range.text = replacementElement;
  }
}
